import { useUnit } from 'effector-react'
import {
  $allUserApprove,
  $modalArticleItem,
  $ceoTeam,
  $users,
} from 'src/pages/budget/model'

export const useUsers = () => useUnit($users)
export const useCeoTeam = () => useUnit($ceoTeam)
export const useAllUserApprove = () => useUnit($allUserApprove)
export const useModalArticleItem = () => useUnit($modalArticleItem)
